module.exports = {
	"pagination": {
		"ListImages": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults",
			"result_key": "imageIds"
		},
		"DescribeImages": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults",
			"result_key": "imageDetails"
		},
		"DescribeRepositories": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults",
			"result_key": "repositories"
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/aws-sdk/apis/ecr-2015-09-21.paginators.json
 ** module id = 1296
 ** module chunks = 0
 **/